'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('../protocol'),
    CircuitPB = _require.CircuitRelay;

var multicodec = require('../multicodec');

var StreamHandler = require('./stream-handler');

var _require2 = require('./utils'),
    validateAddrs = _require2.validateAddrs;

var debug = require('debug');

var log = debug('libp2p:circuit:stop');
log.error = debug('libp2p:circuit:stop:error');
/**
 * Handles incoming STOP requests
 *
 * @private
 * @param {*} options
 * @param {Connection} options.connection
 * @param {*} options.request The CircuitRelay protobuf request (unencoded)
 * @param {StreamHandler} options.streamHandler
 * @returns {Promise<*>} Resolves a duplex iterable
 */

module.exports.handleStop = function handleStop(_ref) {
  var connection = _ref.connection,
      request = _ref.request,
      streamHandler = _ref.streamHandler;

  // Validate the STOP request has the required input
  try {
    validateAddrs(request, streamHandler);
  } catch (err) {
    return log.error('invalid stop request via peer %s', connection.remotePeer.toB58String(), err);
  } // The request is valid


  log('stop request is valid');
  streamHandler.write({
    type: CircuitPB.Type.STATUS,
    code: CircuitPB.Status.SUCCESS
  });
  return streamHandler.rest();
};
/**
 * Creates a STOP request
 * @private
 * @param {*} options
 * @param {Connection} options.connection
 * @param {*} options.request The CircuitRelay protobuf request (unencoded)
 * @returns {Promise<*>} Resolves a duplex iterable
 */


module.exports.stop = /*#__PURE__*/function () {
  var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var connection, request, _yield$connection$new, stream, streamHandler, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            connection = _ref2.connection, request = _ref2.request;
            _context.next = 3;
            return connection.newStream([multicodec.relay]);

          case 3:
            _yield$connection$new = _context.sent;
            stream = _yield$connection$new.stream;
            log('starting stop request to %s', connection.remotePeer.toB58String());
            streamHandler = new StreamHandler({
              stream: stream
            });
            streamHandler.write(request);
            _context.next = 10;
            return streamHandler.read();

          case 10:
            response = _context.sent;

            if (!(response.code === CircuitPB.Status.SUCCESS)) {
              _context.next = 14;
              break;
            }

            log('stop request to %s was successful', connection.remotePeer.toB58String());
            return _context.abrupt("return", streamHandler.rest());

          case 14:
            log('stop request failed with code %d', response.code);
            streamHandler.close();

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function stop(_x) {
    return _stop.apply(this, arguments);
  }

  return stop;
}();